import { googleTagManager } from '@/shared/infrastructure/adapters/googleTagManager';
import { TrackingEvent } from '@/shared/domain/models';
import { TrackingProvider } from './TrackingContext';

declare global {
  interface Window {
    dataLayer: Record<string, any>[];
  }
}

export const onDispatch = (trackingEvent: TrackingEvent) => {
  googleTagManager.sendEvent(trackingEvent, window.dataLayer || []);
};

export const GlobalContext = ({ children }) => {
  return (
    <TrackingProvider appName="b2b-authentication-app" onDispatch={onDispatch}>
      {children}
    </TrackingProvider>
  );
};
